import { render, staticRenderFns } from "./website-identify.vue?vue&type=template&id=2a6c5173&scoped=true"
import script from "./website-identify.vue?vue&type=script&lang=js"
export * from "./website-identify.vue?vue&type=script&lang=js"
import style0 from "./website-identify.vue?vue&type=style&index=0&id=2a6c5173&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6c5173",
  null
  
)

export default component.exports